// extracted by mini-css-extract-plugin
export var downArrow = "_b6-0";
export var label = "_b6-1";
export var treatmentCard = "_b6-3";
export var upArrow = "_b6-2";